import React, { FC } from 'react';
import LastOrderDate from 'components/Common/LastOrderDate/LastOrderDate';
import { LastOrderDateBlock } from 'store/landing/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './LandingPageLastOrderDate.module.scss';

export interface LastOrderDateBlockProps {
  lastOrderDateBlockData: LastOrderDateBlock;
}

const LandingPageLastOrderDate: FC<LastOrderDateBlockProps> = ({ lastOrderDateBlockData }) => {
  const { theme } = useLandingPageContext();

  const {
    title,
    description,
    expressShippingColumnTitle,
    expressShippingColumnTitleShort,
    productColumnTitle,
    standardShippingColumnTitleShort,
    standardShippingColumnTitle,
  } = lastOrderDateBlockData;

  return (
    <div className={styles.container}>
      <LastOrderDate
        type="lg"
        theme={theme}
        title={title}
        description={description}
        expressShippingHeader={expressShippingColumnTitle}
        expressShippingHeaderShort={expressShippingColumnTitleShort}
        standardShippingHeader={standardShippingColumnTitle}
        standardShippingHeaderShort={standardShippingColumnTitleShort}
        productHeader={productColumnTitle}
      />
    </div>
  );
};

export default LandingPageLastOrderDate;
